import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import MessageUI from '../../widgets/output/MessageUI'
import FormSF from '../../widgets/form/FormSF'
import InputNameSF from '../../widgets/form/InputNameSF'
import InputTextSF from '../../widgets/form/InputTextSF'

const SignUpOnInviteAcceptUI = ({context, messageList, onSubmit, submitted, successMsg, errorList, setErrorList,
    // name
    firstName, lastName, onFirstNameChange, onLastNameChange, firstNameError, lastNameError, setFirstNameError, setLastNameError,
    // password
    password, onPasswordChange, passwordError, setPasswordError,
    accountName, email
  }) =>
  <CardUI context={context}>
    <FormSF context={context} className='pub_signup' messageList={messageList} buttonMessageKey='c_sign_up'
        onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
        busy={submitted}>
      <b><MessageUI messageList={messageList} messageKey='c_invitation_accepted' /></b>
      <div className='g_m_top_100'>
      <MessageUI messageList={messageList} messageKey='c_acct_inv_acpt_signup'
        args={[accountName, email]} />
      </div>
      <InputNameSF type='name' required={true} name='name' firstName={firstName} lastName={lastName}
        messageList={messageList} labelKey='c_name'
        firstNameError={firstNameError} lastNameError={lastNameError}
        onFirstNameChange={onFirstNameChange} onLastNameChange={onLastNameChange}
        setFirstNameError={setFirstNameError} setLastNameError={setLastNameError}
      />
      <InputTextSF type='password' name='password' required={true} maxLength={40}
        messageList={messageList} labelKey='c_password'
        value={password} onChange={onPasswordChange}
        error={passwordError} setError={setPasswordError}
        autoFocus={true}
      />
    </FormSF>
  </CardUI>

export default SignUpOnInviteAcceptUI
